import * as _ from 'lodash';
import type { AppAllCodeMap } from '@/types/type';
import type { Dayjs } from 'dayjs'
import { convertUtils } from '~/composable/util';

export const useCodeMapStore = defineStore('codeMapStore', () => {
  
  const codeMap = ref<AppAllCodeMap>();
  const time = ref<Dayjs|null>(null);

  const getCodeMapByCode = (code: string) => codeMap.value![code];
  const getOptionsByCode = (code: string, sortByValue: boolean) => convertUtils().convertObjectToOptions(getCodeMapByCode(code), sortByValue);

  return { codeMap, time, getCodeMapByCode, getOptionsByCode }  
})
